import React from 'react';
import { Field } from '../../../headless/field';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicTextInputProps } from '../../../types/public-props';

import { Input } from './input';
import {
  BaseDescription,
  BaseError,
  BaseLabel,
  type BaseLabelComponent,
} from '../../../headless/base';

export interface TextInputProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

const Root = React.forwardRef<HTMLDivElement, TextInputProps>((props, ref) => {
  const { asChild, className, children } = props;
  const { id } = useFieldProps<PublicTextInputProps>();

  return (
    <Field id={id} ref={ref} asChild={asChild} className={className}>
      <Field.Input>{children}</Field.Input>
    </Field>
  );
});

Root.displayName = 'TextInput';

interface TextInputComponent
  extends React.ForwardRefExoticComponent<
    TextInputProps & React.RefAttributes<HTMLDivElement>
  > {
  Label: BaseLabelComponent<PublicTextInputProps>;
  Input: typeof Input;
  Error: typeof BaseError<PublicTextInputProps>;
  Description: typeof BaseDescription<PublicTextInputProps>;
}

export const TextInput = Root as TextInputComponent;
TextInput.Label = BaseLabel;
TextInput.Input = Input;
TextInput.Error = BaseError;
TextInput.Description = BaseDescription;
